// extracted by mini-css-extract-plugin
module.exports = {"iconWrapper":"t4","hide":"t5"};